
export const PREDEFINED_PROMPTS = [
  "Show SMS vendor performance today",
  "give me sms dashboard for last 5 days Customer wise",
  "give me sms dashboard for last 5 days Date wise",
  "give me sms dashboard",
];